import Vue from "vue";
import ApiService from "@/core/services/api.service";
// const actionScope = `loader`;
export function setupInterceptors({ dispatch }) {
  let httpClient = ApiService.getInstance();
  let requestsPending = 0;
  const req = {
    pending: () => {
      requestsPending++;
      dispatch(`show`);
    },
    done: () => {
      requestsPending--;
      if (requestsPending <= 0) {
        dispatch(`hide`);
      }
    }
  };
  httpClient.interceptors.request.use(
    config => {
      req.pending();
      return config;
    },
    error => {
      requestsPending--;
      req.done();
      return Promise.reject(error);
    }
  );
  httpClient.interceptors.response.use(
    response => {
      req.done();
      return Promise.resolve(response);
    },
    error => {
      req.done();

      const vm = new Vue();
      vm.$bvToast.toast(`${error.response.data.message}`, {
        title: "Server Error",
        variant: "danger"
      });

      return Promise.reject(error);
    }
  );
}
